// DiversityDetails
import React, { useState } from "react";

function DiversityDetails() {
  const [gender, setGender] = useState("All candidates");
  const [isPWD, setIsPWD] = useState(false);
  const [category, setCategory] = useState("");
  const [minAge, setMinAge] = useState("");
  const [maxAge, setMaxAge] = useState("");

  return (
    <div className="mb-4">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        Diversity and Additional Details
      </h2>

      {/* Gender Selection */}
      <div className="mb-4">
        <label className="block text-gray-700 font-semibold mb-2">
          Diversity details
        </label>
        <div className="flex gap-2 mb-2">
          <button
            className={`py-2 px-4 border rounded-md ${
              gender === "All candidates"
                ? "bg-blue-100 text-blue-600 border-blue-500"
                : "text-gray-600 border-gray-300"
            }`}
            onClick={() => setGender("All candidates")}
          >
            All candidates
          </button>

          <button
            className={`py-2 px-4 border rounded-md ${
              gender === "Male candidates"
                ? "bg-blue-100 text-blue-600 border-blue-500"
                : "text-gray-600 border-gray-300"
            }`}
            onClick={() => setGender("Male candidates")}
          >
            Male candidates
          </button>

          <button
            className={`py-2 px-4 border rounded-md ${
              gender === "Female candidates"
                ? "bg-blue-100 text-blue-600 border-blue-500"
                : "text-gray-600 border-gray-300"
            }`}
            onClick={() => setGender("Female candidates")}
          >
            Female candidates
          </button>

          <button
            className={`py-2 px-4 border rounded-md ${
              gender === "Others"
                ? "bg-blue-100 text-blue-600 border-blue-500"
                : "text-gray-600 border-gray-300"
            }`}
            onClick={() => setGender("Others")}
          >
            Others
          </button>

        </div>
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            checked={isPWD}
            onChange={() => setIsPWD(!isPWD)}
            className="form-checkbox text-blue-600 mr-2"
          />
          <span className="text-gray-700">Person with Disabilities only</span>
        </label>
      </div>

      {/* Candidate Category */}
      <div className="mb-4">
        <label className="block text-gray-700 font-semibold mb-2">
          Candidate Category
        </label>
        <input
          type="text"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          placeholder="Add candidate category"
          className="w-full border rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Candidate Age */}
      <div className="mb-4">
        <label className="block text-gray-700 font-semibold mb-2">
          Candidate Age
        </label>
        <div className="flex gap-2">
          <input
            type="number"
            value={minAge}
            onChange={(e) => setMinAge(e.target.value)}
            placeholder="Min age"
            className="w-1/2 border rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <span className="flex items-center">to</span>
          <input
            type="number"
            value={maxAge}
            onChange={(e) => setMaxAge(e.target.value)}
            placeholder="Max age"
            className="w-1/2 border rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <span className="text-gray-500">Years</span>
        </div>
      </div>
    </div>
  );
}

export default DiversityDetails;
